/* @flow */

import * as React from 'react';

import type {SelectBaseProps} from 'react-select';

import {colors} from 'shells/colors';

import {SelectPickerGeneric} from 'shells/select-picker-generic';

import './select-with-icon.css';

type SelectWithIconOption = {
    value: string,
    label: string,
    icon: React.ComponentType<*>,
};

export type Props = {|
    ...$Exact<SelectBaseProps>,
    value?: ?string,
    options: SelectWithIconOption[],
    onChange: (value: string) => void,
    selectRef: any,
|};

export function SelectWithIcon(props: Props) {
    // isMulti and isClearable throw a flow error on Select Picker Generic
    // eslint-disable-next-line no-unused-vars
    const {isMulti, isClearable, onBlur, value, selectRef, ...restProps} = props;

    function formatOptionLabel(option: SelectWithIconOption) {
        const Icon = option.icon;

        return (
            <div styleName='select-with-icon-option'>
                <Icon alignCenter={true} size={14} />
                <div styleName='label'>{option.label}</div>
            </div>
        );
    }

    const styles = {
        control: (base) => ({
            ...base,
            '&:hover': {
                borderColor: colors.greyLt,
            },
            border: `1px solid ${colors.formBorder}`,
            borderRadius: 3,
        }),
    };

    const selectedValue = props.options.find((option) => option.value === value);

    return (
        <SelectPickerGeneric
            {...restProps}
            value={selectedValue}
            onChange={(option) => {
                props.onChange(option.value);
            }}
            options={props.options}
            styles={styles}
            formatOptionLabel={formatOptionLabel}
            isSearchable={false}
            ref={selectRef}
        />
    );
}
